export function mapStateToProps(state) {
  return {
    enrollmentOpen: state.config.enrollmentOpen,
  };
}

export function mapDispatchToProps() {
  return {};
}
